import { merchantState } from './merchant.state';
import { merchantActions } from './merchant.actions';
import { merchantGetters } from './merchant.getters';
import { merchantMutations } from './merchant.mutations';

export default {
  state: merchantState,
  actions: merchantActions,
  getters: merchantGetters,
  mutations: merchantMutations,
};
